const whDailyDc = {
  dc: 'DC',
  assessMonth: 'AssessMonth',
  assessMonthStart: 'StartMonth',
  assessMonthEnd: 'EndMonth',
  carrierCode: 'CarrierCode',
  serviceProvider: 'ServiceProvider',
  assessItem: 'AssessItem',
  category: 'Category',
  categoryType: 'CategoryType',
  subCategory: 'SubCategory',
  versionNo: 'VersionNo',
  briefDesc: 'BriefDesc',
  assessContent: 'AssessContent',
  citationClause: 'CitationClause',
  score: 'Score',
  deduction: 'Deduction',
  breachExample: 'BreachExample',
  createTime: 'CreateTime',
  msg: {}
};
export default whDailyDc;



// WEBPACK FOOTER //
// ./src/page/assess/whDailyDc/lang/whDailyDc.en.js